import { useEffect, useState } from 'react'
import img from '../../../../assets/image 75 (1).png'
import imgMob from '../../../../assets/image 75.png'
import './index.scss'
import { ReactComponent as Heart } from '../../../../assets/Vector.svg'
import { ReactComponent as Arrow } from '../../../../assets/arrow-left.svg'

import ContentState from '../../../../stores/ContentState'
import { observer } from 'mobx-react'
import Hearts from '../../../common/Hearts'
import GlobalState from '../../../../stores/GlobalState'
const FifthScreen = observer(() => {
  const [img1, setImg] = useState<any>(null)
  useEffect(() => {
    fetch(window.innerWidth > 768 ? img : imgMob)
      .then((fetchResponse) => {
        if (fetchResponse.ok) {
          return fetchResponse
        }
      })
      .then((response) => response!.blob())
      .then((imageBlob) => {
        const imageObjectURL: any = URL.createObjectURL(imageBlob)
        setImg(imageObjectURL)
      })
  }, [])

  const hearts = (count: number) => {
    return Array(count).fill(0)
  }
  const getClass = (id: number) => {
    const classes = [
      'topright',
      'topleft',
      'bottomright',
      'middlebottomleft',
      'bottomleft',
      'middlebottomright',
      'up',
      'down',
      'middletopleft',
      'right',
      'left',
      'middletopright',
    ]

    return classes[
      id >= classes.length ? Math.floor(id / classes.length) - 1 : id
    ]
  }

  if (!ContentState.home?.fifthscreen) return <></>

  return (
    <section className="screen section friendly page" id="friendly">
      <div className="screen__container">
        <div className="screen__row">
          <div className="screen__title">
            <span
              dangerouslySetInnerHTML={{
                __html: ContentState.home.fifthscreen.title,
              }}
            ></span>
            <span style={{ whiteSpace: 'nowrap' }}>
              <Heart className="screen__heart" />
              <Hearts />
            </span>
          </div>
          <div
            className="screen__text"
            dangerouslySetInnerHTML={{
              __html: ContentState.home.fifthscreen.text,
            }}
          ></div>
        </div>
        <div className="screen__bottom friendly ">
          <div className="screen__bottom-btns">
            <div
              className="button friendly "
              onClick={() => {
                // let lang = GlobalState.currentLocale.lang.includes('En')
                //   ? '/en'
                //   : GlobalState.currentLocale.lang.includes('ру')
                //   ? '/ru'
                //   : ''
              // lang + 
                window.location.href =
                  ContentState.home!.buttonFriendly.link
              }}
            >
              <span>{ContentState.home.buttonFriendly.title}</span>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="screen__post"
        onClick={() =>
          (window.location.href = ContentState.home!.fifthscreen.postLink)
        }
      >
        <div className="screen__post-left">
          <div
            className="screen__post-title"
            dangerouslySetInnerHTML={{
              __html: ContentState.home.fifthscreen.postTitle,
            }}
          ></div>
          <span className="screen__post-btn">
            <Arrow />
          </span>
        </div>
        <div className="screen__post-img">
          <img src={ContentState.home.fifthscreen.postImg} />
        </div>
      </div> */}

      <div className="screen__bg">{img1 && <img src={img1} />}</div>
    </section>
  )
})

export default FifthScreen
